/**
 * @module features/devices/api/useDevices
 * @description Query hook for the paginated/filterable device list.
 */
import { useQuery } from "@tanstack/react-query";
import { DevicesQueryParams } from "../types";
import { deviceKeys, getDevices } from "./devices-api";

export function useDevices(params: DevicesQueryParams) {
  return useQuery({
    queryKey: deviceKeys.list(params),
    queryFn: () => getDevices(params),
    // Keep the previous page on screen while the next loads (no layout jump).
    placeholderData: (previous) => previous,
  });
}
